import PropTypes from "prop-types";

import ChallengeEarnedTokenContent from "@/view/ArticleActivityPicker/ChallengeEarnedTokenContent";
import useIsAuthorizedForIndependentReadingChallenge from "@/challenges/utils/useIsAuthorizedForIndependentReadingChallenge/useIsAuthorizedForIndependentReadingChallenge";
import useArticleGetByContentId from "@/challenges/utils/useArticleGetByContentId";
import PowerWordQuizResponseItem from "../PowerWordQuizResponseItem";
import PowerWordSummaryInfo from "../PowerWordSummaryInfo";
import {
  dividerCss,
  responseItemContainerCss,
} from "../QuizSummary/QuizSummary.style";
import SummaryItemCount from "../QuizSummary/SummaryItemCount";
import getPowerWordsPoints from "../utils/getPowerWordsPoints";

const propTypes = {
  sanitizedStudentPowerWordQuizData: PropTypes.array,
  contentId: PropTypes.string,
};

const PowerWordQuizSummary = ({
  sanitizedStudentPowerWordQuizData,
  contentId,
}) => {
  const isAuthorizedChallengesPageUser =
    useIsAuthorizedForIndependentReadingChallenge();
  const { data: articleData } = useArticleGetByContentId(contentId);

  const getTotalQuestions = () => sanitizedStudentPowerWordQuizData.length * 2;
  const getTotalAnswersCorrect = () => {
    const totalQuestionsAnswered = [];
    sanitizedStudentPowerWordQuizData.forEach((question) =>
      totalQuestionsAnswered.push(question.isCorrect),
    );
    return totalQuestionsAnswered
      .flatMap((x) => x)
      .filter((isCorrect) => isCorrect === true).length;
  };

  const renderQuizResponseItem = (question, index) => (
    <PowerWordQuizResponseItem
      key={`question-item-${index}`}
      question={question}
    />
  );

  return (
    <>
      <SummaryItemCount
        correctAnswerCount={getTotalAnswersCorrect()}
        isPowerWordQuiz
        points={getPowerWordsPoints(
          getTotalQuestions(),
          getTotalAnswersCorrect(),
        )}
        count={getTotalQuestions()}
      />
      {isAuthorizedChallengesPageUser && (
        <ChallengeEarnedTokenContent
          isStudent
          articleData={articleData}
          type="Power Words"
        />
      )}
      <PowerWordSummaryInfo
        correctAnswerCount={getTotalAnswersCorrect()}
        totalQuestionsCount={getTotalQuestions()}
        points={getPowerWordsPoints(
          getTotalQuestions(),
          getTotalAnswersCorrect(),
        )}
      />
      <div css={responseItemContainerCss}>
        {sanitizedStudentPowerWordQuizData?.map((question, index) => {
          return (
            <div key={`question-item-${index}`}>
              {renderQuizResponseItem(question)}
              {index !== sanitizedStudentPowerWordQuizData.length - 1 && (
                <div css={dividerCss} />
              )}
            </div>
          );
        })}
      </div>
    </>
  );
};

PowerWordQuizSummary.propTypes = propTypes;

export default PowerWordQuizSummary;
